import declare from "dojo/_base/declare";
import domClass from "dojo/dom-class";
import domStyle from "dojo/dom-style";
import query from "dojo/query";
import _ from "csi/_base/underscore";
import stateColorResolver from "csi/heading/stateColorResolver";
import html from "csi/html";
import StateWidget from "csi/html/StateWidget";
import locale from "csi/locale";
import xml from "csi/xml";

const PURPOSE_IMPACT_ANALYSIS =  "ECPurpose:ImpactAnalysis";

const ECStateHeaderView = declare(StateWidget, {
	/**
	 * @override
	 * Apply styling for active state
	 */
	_processHtml: function(ctx, dom) {
		this.inherited(arguments);

		const node = ctx.getNode();
		const css = stateColorResolver.getStateCss(node);
		const stateEnumValue = xml.enumGetText(node.State);
		
		// Hide EC State Header when purpose is impact analysis
		const purpose = node.Purpose;
		if (purpose === PURPOSE_IMPACT_ANALYSIS) {
			const stateHeaderDom = dom.parentNode.parentNode;
			domStyle.set(stateHeaderDom, "display", "none");
		}

		var eCanceled = query(".canceled", dom)[0];
		if (eCanceled) {
			html.text(eCanceled, locale.getEnumName("ECState:Canceled", true));
			domClass.add(eCanceled, css);
		} else {
			var eDraft = query(".draft", dom)[0];
			var eReview = query(".review", dom)[0];
			var eApproved = query(".approved", dom)[0];

			html.text(eDraft, locale.getEnumName("ECState:Draft", true));
			html.text(eReview, locale.getEnumName("ECState:Review", true));
			html.text(eApproved, locale.getEnumName("ECState:Approved", true));

			switch (stateEnumValue) {
				case "Draft": domClass.add(eDraft, css); break;
				case "Review": domClass.add(eReview, css); break;
				case "Approved": domClass.add(eApproved, css); break;
			}
		}
	},
});

export = ECStateHeaderView;
